// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPremium_root__2jCOi","icon":"IconPremium_icon__2GWal"};